import { FC, useEffect, useState } from 'react';
import Transfer from './components/Transfer';
import PaymentsList from './components/PaymentsList';
import TotalPrice from './components/TotalPrice';
import PaymentsEditOrder from './components/EditOrder';
import PaymentsButtons from './components/ButtonsContainer';
import ChargeModal from './components/modals/ChargedModal';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { IOrderFetch } from 'src/models/IOrder';
import './styles.scss';

interface IProps {
  order: IOrderFetch;
}

const Payments: FC<IProps> = ({ order }) => {
  const { id, handle_payments } = order;

  const { getOrder } = useActions();
  const hostId = useTypedSelector(state => state.auth.id);
  const hostList = useTypedSelector(state => state.host.hostList);
  const resultCharge = useTypedSelector(state => state.order.result.charge);

  const [openPayTextModal, setOpenPayTextModal] = useState(false);
  const [payText, setPayText] = useState('');
  const [isStripeId, setIsStripeId] = useState(false);

  useEffect(() => {
    const host = hostList.find(host => host.id === hostId);
    host && host.stripe_connect_id && setIsStripeId(true);
  }, [hostList, hostId]);

  useEffect(() => {
    if (resultCharge?.data) {
      setPayText(resultCharge.data), setOpenPayTextModal(true);
    }
  }, [resultCharge]);

  const handleCloseCharge = () => {
    resultCharge?.data && getOrder(id);
    setOpenPayTextModal(false);
  };

  return (
    <>
      <div>
        <div className='order-show__title'>Payments</div>
        <PaymentsList order_id={id} isStripeId={isStripeId} payments={handle_payments} />
        <PaymentsButtons order_id={id} isStripeId={isStripeId} />
        <TotalPrice order={order} />
        <PaymentsEditOrder order={order} isStripeId={isStripeId} />
      </div>
      <Transfer order={order} />
      {resultCharge && (
        <ChargeModal open={openPayTextModal} handleClose={handleCloseCharge} text={payText} />
      )}
    </>
  );
};

export default Payments;
